import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Security } from 'app/model/security.model';
import { Router } from '@angular/router';
import { UserFLT } from 'app/model/userflt.model';
import { User } from 'app/model/user.model';

@Injectable()
export class AppService implements Resolve<any>
{
    security = new Security();
    User: any[];
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient,
        private router: Router
    ) {
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {
            Promise.all([]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }




    /**
     * Get talkings
     *
     * @returns {Promise<any>}
     */
    getUser(Email): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.security.AppEngine + 'api/user/' + Email)
                .subscribe((response: any) => {
                    this.User = response[0];
                    resolve(this.User);
                }, reject);
        });
    }

   

    logar(usuario: UserFLT): Promise<any> {
        
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.security.AppEngine + 'api/fltuser/', { ...usuario })
                .subscribe((response: any) => {
                    if (response.length > 0) {
                        this.User = response[0];
                        

                        localStorage.setItem('token', btoa(JSON.stringify("TokenQueSeriaGeradoPelaAPI")));
                        localStorage.setItem('usuario', btoa(JSON.stringify(this.User)));
                        this.router.navigate(['/opportunitylist']);
                    }

                    resolve(this.User);


                }, reject);
        });

    }

    login(user: User) : Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.security.AppEngine + 'api/user/' + user.Email + '/', { ...user })
                .subscribe((response: any) => {
                    if (response.length > 0) {
                        this.User = response[0];
                        localStorage.setItem('token', btoa(JSON.stringify("TokenQueSeriaGeradoPelaAPI")));
                        localStorage.setItem('flt-user', btoa(JSON.stringify(this.User)));                    
                        localStorage.setItem('flt-licence', btoa(JSON.stringify(this.User["ControlDownloadId"])));
                        this.router.navigate(['/register/infra']);
                    }
                    resolve(this.User);
                }, reject);
        });
    }

    setLicence(licence) : Promise<any> {
        return new Promise((resolve, reject) => {
            localStorage.setItem('flt-licence', btoa(licence));
            
            resolve(licence);
        });

    }

    getLicence(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (localStorage.getItem('flt-licence')) {
                resolve((JSON.parse(atob(localStorage.getItem('flt-licence')))));
            }
            else {
                resolve('');
            }
            
        });
    }



    logout() {
        localStorage.clear();
        this.router.navigate(['/login']);
    }

    private mockUsuarioLogin(usuario: UserFLT): Observable<any> {
        var retornoMock: any = [];

        if (usuario.Email === "hello@balta.io" && usuario.Password == "123") {
            retornoMock.sucesso = true;
            retornoMock.usuario = usuario;
            retornoMock.token = "TokenQueSeriaGeradoPelaAPI";
            return retornoMock;
        }

        retornoMock.sucesso = false;
        retornoMock.usuario = usuario;
        return retornoMock;
    }

    deslogar() {
        localStorage.clear();
        this.router.navigate(['/fltlogin']);
    }

    get obterUsuarioLogado(): UserFLT {
        return localStorage.getItem('usuario')
            ? JSON.parse(atob(localStorage.getItem('usuario')))
            : null;
    }

    get obterIdUsuarioLogado(): string {
        return localStorage.getItem('usuario')
            ? (JSON.parse(atob(localStorage.getItem('usuario'))) as UserFLT).Id
            : null;
    }

    get obterTokenUsuario(): string {
        return localStorage.getItem('token')
            ? JSON.parse(atob(localStorage.getItem('token')))
            : null;
    }

    get logado(): boolean {
        return localStorage.getItem('token') ? true : false;
    }

    get logged(): boolean {
        return localStorage.getItem('token') ? true : false;
    }

    obterEmailUsuarioLogado(): string {

        console.log(localStorage.getItem('usuario'));
        return localStorage.getItem('usuario')
            ? (JSON.parse(atob(localStorage.getItem('usuario'))) as UserFLT).Email
            : null;
    }

    getEmail(): Promise<any> {
        return new Promise((resolve, reject) => {
            var UserEmail = '';
            if (localStorage.getItem('flt-user')) {
                resolve((JSON.parse(atob(localStorage.getItem('flt-user'))) as User).Email);
            }
            else {
                resolve('');
            }
            
        });
    }


    getSession(): Promise<any> {
        return new Promise((resolve, reject) => {
            var UserEmail = '';
            if (localStorage.getItem('flt-user')) {
                resolve((JSON.parse(atob(localStorage.getItem('flt-user'))) as User).ControlDownloadId);
            }
            else {
                resolve('');
            }
            
        });
    }


    getUserEmail(): Promise<any> {
        return new Promise((resolve, reject) => {
            var UserEmail = '';
            if (localStorage.getItem('usuario')) {
                resolve((JSON.parse(atob(localStorage.getItem('usuario'))) as UserFLT).Email);
            }
            else {
                resolve('');
            }
            
        });
    }

}
